import { render } from "./SpmKeyCard.vue?vue&type=template&id=793e3c98&scoped=true"
import script from "./SpmKeyCard.vue?vue&type=script&lang=ts"
export * from "./SpmKeyCard.vue?vue&type=script&lang=ts"

import "./SpmKeyCard.vue?vue&type=style&index=0&id=793e3c98&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-793e3c98"

export default script